import React from "react";
import GameWindowHeader from "../GameWindowHeader";
import GameWindowBg from "../GameWindowBg";
import {LOCO_HEADER_COLOR, PROBLEM_COLORS} from "../GameStyleUI";
import train_icon from "../../../images/gameplay_ui/icons/loco_icon.svg";
import plus_icon from "../../../images/gameplay_ui/icons/plus.svg";
import minus_icon from "../../../images/gameplay_ui/icons/minus.svg";
import is_break_down from "../../../images/gameplay_ui/icons/is_break_down_small.svg";
import train_car_icon from "../../../images/gameplay_ui/icons/car_train_icon.svg";
import short_train_icon from "../../../images/gameplay_ui/icons/path/short_train_icon.svg";
import long_train_icon from "../../../images/gameplay_ui/icons/path/long_train_icon.svg";
import GameController from "../../../gameplay/controllers/GameController";
import GameButtonWithIcon from "../GameButtonWithIcon";
import StateBar from "../StateBar";
import CurrencyCard from "./CurrencyCard";
import GameData from "../../../gameplay/model/GameData";
import {RepairValue} from "../../../gameplay/model/Balance";
import {INFRA_TYPE, STATION_NAMES} from "../../../constants/Constants";
import {useDrop} from "react-dnd";
import SmallTrainCard from "./SmallTrainCard";
import agent from "../../../agent";
import UtilsFunctions from "../../../utils/UtilsFunctions";

const onAddRepairChip = props => {
  let path = props.path;
  if (isCanAddRepairState(props)) return;
  path.forRepairChips++;
  agent.GamePlay.setPathRepairState(props.teamID, {
    pathId: path.id,
    forRepairChips: path.forRepairChips,
    forRepairBreawdownChips: path.forRepairBreawdownChips
  }, (response) => {
    console.log(response)
    props.parent.readGameData();
    props.parent.forceUpdate();
  });
}
const onRemoveRepairChip = props => {
  let path = props.path;
  if (path.forRepairChips === 0) return;
  path.forRepairChips--;
  agent.GamePlay.setPathRepairState(props.teamID, {
    pathId: path.id,
    forRepairChips: path.forRepairChips,
    forRepairBreawdownChips: path.forRepairBreawdownChips
  }, (response) => {
    console.log(response);
    props.parent.readGameData();
    props.parent.forceUpdate();
  });

}
const onAddRepairBreawdownChips = props => {
  let path = props.path;
  path.forRepairBreawdownChips++;
  agent.GamePlay.setPathRepairState(props.teamID, {
    pathId: path.id,
    forRepairChips: path.forRepairChips,
    forRepairBreawdownChips: path.forRepairBreawdownChips
  }, (response) => {
    console.log(response)
    props.parent.readGameData();
    props.parent.forceUpdate();
  });
}
const onRemoveRepairBreawdownChips = props => {
  let path = props.path;
  if (path.forRepairBreawdownChips === 0) return;
  path.forRepairBreawdownChips--;
  agent.GamePlay.setPathRepairState(props.teamID, {
    pathId: path.id,
    forRepairChips: path.forRepairChips,
    forRepairBreawdownChips: path.forRepairBreawdownChips
  }, (response) => {
    console.log(response);
    props.parent.readGameData();
    props.parent.forceUpdate();
  });

}
const isCanAddRepairState = props => {
  let path = props.path;
  let repairShop = GameData.CurrentGame.getRepairShopByType(INFRA_TYPE)
  return path.forRepairChips + path.state === RepairValue
    || GameController.calculateAvaliablePartsPath(repairShop) === 0
    || GameController.calculateAvaliableBrigadesChipsPath(repairShop) === 0
}
const isCanRemoveBreakdownChips = props => {
  const shop = GameData.CurrentGame.getRepairShopByType(INFRA_TYPE)
  const parts = GameController.calculateAvaliablePartsPath(shop);
  const people = GameController.calculateAvaliableBrigadesChipsPath(shop);
  return parts > 0 && people > 0;
}

const isRightPhaseAndRoleForRepair = () => {
  return GameData.CurrentGame.state === 3 && UtilsFunctions.playerHasRole(3); // зам по ремонту
}
const isRightPhaseAndRoleForRemove = () => {
  return GameData.CurrentGame.state === 4 && UtilsFunctions.playerHasRole(6); // зам по тяге
}

const PathCard = (props) => {
  const [{isOver}, drop] = useDrop(
    () => ({
      accept: 'train',
      drop: props.onDrop,
      collect: (monitor) => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop()
      })
    }),
    ['train', props.onDrop]
  );

  if (window.removeRequestSent) {
    return <div></div>;
  }

  if (isOver) {
  }
  let path = props.path;

  // Берем значения из констант
  let initialX = props.x ?? 0;
  let initialY = props.y ?? 0;
  // Версталось поле на таком экране
  let initialScreen = {w: 1920, h: 937};
  // Рассчитываем пропорцию
  let left = window.innerWidth * initialX / initialScreen.w;
  let top = window.innerHeight * initialY / initialScreen.h;

  let mainStyle = {
    position: "absolute",
    left: `${left}px`,
    top: `${top}px`,
    display: "flex",
    flexDirection: "column",
    alignItems: props.facingLeft ? "flex-start" : "flex-end"
  }
  let lineStyle = {
    height: "20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "5px"
  }
  let rightDiv = {
    width: "51px",
    fontSize: "14px",
    lineHeight: "14px",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center"
  }
  let trainCardsContainerStyle = {
    position: "absolute",
    top: "-40px",
    left: 0,
    display: "flex"
  }
  let content = [];
  let trainCardsSmall = [];
  let trainIDs = path.currentTrainIDs;
  for (let j = 0; j < trainIDs.length; j++) {
    let train = GameData.CurrentGame.getTrainById(trainIDs[j]);
    if (!train) {
      window.removeRequestSent = true;
      agent.GamePlay.removeTrainFromPath(props.teamID, {
          pathId: path.id,
          trainId: trainIDs[j]
        },
        response => {
          console.log(response)
          window.location.reload();
        });
      return <div></div>;
    }

    if (train.locomotives.length) {
      trainCardsSmall.push(<SmallTrainCard key={j} train={train} path={path} onClick={() => {
        if (isRightPhaseAndRoleForRemove()) {
          agent.GamePlay.removeTrainFromPath(props.teamID, {
              pathId: path.id,
              trainId: train.id
            },
            response => console.log(response));
        }
      }
      }/>);
    }
  }
  let throughput = GameController.calculateAvailablePathThroughput({path, teamID: props.teamID});
  content.push(<div style={trainCardsContainerStyle} key={1}>
    {trainCardsSmall}
  </div>);
  content.push(<div style={lineStyle} key={2}>
    <div style={rightDiv}>
      <img src={train_icon} alt={"icon"} style={{width: "20px", height: "20px", paddingRight: "5px"}}/>
      <img alt={"icon"} src={path.trainType === 0 ? short_train_icon : long_train_icon}
           title={path.trainType === 0 ? "Обычный" : "Длинносоставный"}/>
    </div>
    <div style={rightDiv}>
      <img alt={"icon"} src={train_car_icon} style={{width: "20px", height: "20px", paddingRight: "5px"}}
           title={"Пропускная способность"}/>
      {throughput}
    </div>
  </div>);
  content.push(<div style={lineStyle} key={3}>
    <GameButtonWithIcon
      icon={minus_icon}
      width={20}
      height={20}
      disabled={!isRightPhaseAndRoleForRepair() || path.forRepairChips === 0}
      onClick={() => onRemoveRepairChip(props)}
    />
    <StateBar state={path.state} forRepair={path.forRepairChips}/>
    <GameButtonWithIcon
      icon={plus_icon}
      width={20}
      height={20}
      disabled={!isRightPhaseAndRoleForRepair() || isCanAddRepairState(props)}
      onClick={() => onAddRepairChip(props)}
    />
  </div>);
  content.push(<div style={lineStyle} key={4}>
    <GameButtonWithIcon
      icon={minus_icon} width={20} height={20}
      disabled={!isRightPhaseAndRoleForRepair() || !isCanRemoveBreakdownChips() || path.breakDownChips === 0 || path.breakDownChips === path.forRepairBreawdownChips}
      onClick={() => onAddRepairBreawdownChips(props)}/>
    <CurrencyCard title={"Потеря мощности"} icon={is_break_down}
                  value={path.breakDownChips - path.forRepairBreawdownChips} size={20} textColor={"black"}
                  fontSize={14}/>
    <GameButtonWithIcon icon={plus_icon} width={20} height={20}
                        disabled={!isRightPhaseAndRoleForRepair() || path.breakDownChips === 0 || path.forRepairBreawdownChips === 0}
                        onClick={() => onRemoveRepairBreawdownChips(props)}/>
  </div>);
  content = <div style={{position: "relative"}}>{content}</div>
  let colors = throughput >= 0 ? LOCO_HEADER_COLOR[path.locoType] : PROBLEM_COLORS;
  let stations = path.connectedStations;

  return <div style={mainStyle} className={"path-" + path.id} ref={drop}>

    <GameWindowBg width={139} height={90} value={content}/>
    <GameWindowHeader
      width={30}
      height={30}
      title={path.id}
      iconSize={16}
      fontSize={12}
      fontWeight={"bold"}
      positionTop={10}
      positionLeft={12}
      colorStart={colors[0]}
      colorEnd={colors[1]}
      tooltip={STATION_NAMES[stations[0]] + " - " + STATION_NAMES[stations[1]]}
      onClick={props.showPathDetails}
    />
  </div>
}

export default PathCard;
